import React, {Component} from 'react';
import logo from "./applogo.png";
import Box from '@material-ui/core/Box';
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import './App.css';
import members from "./members.png";
import facility from "./garage.png";
import insurance from "./insurance2.png";
import logo3 from "./iAuthoLogo.png";
import AboutPage from "./AboutPage";
import StartHereIcon from '../assets/img/start_here_icon.png'
import AboutPaymentsPage from "./AboutPaymentsPage";

import appstore from "./appstore.png";
import playstore from "./playstore.png";
import appstore1 from "../assets/img/appstore1.png";
import playstore1 from "../assets/img/playstore1.png";
import footerlogo from "./footer-logo.png";
import sliderbanner from "../assets/img/banner.png";
import sliderbanner1 from "./innerbanner.png";
import sliderbanner2 from "./innerbanner.png";
import chat from "../assets/img/chat.png";
import {appleStoreUrl, googlePlayStoreUrl} from "../variables/constants";



class HomePage extends Component {
  constructor(props){
    super(props);

    this.state = {
      email: '',
      tabIdx: 0,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const message = urlParams.get('message');
    if (message) {
      alert(message);
    }
  }

  handleChange(e) {
    let target = e.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    let name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleTabChange(e, newValue) {
    this.setState({
      tabIdx: newValue,
    })
  }

  handleSubmit(e) {
    e.preventDefault();
  }

  popMenu(e){
    let menu = document.getElementById('navbarNavDropdown1')
    let menu1 = document.getElementById('navbarNavDropdown')

    if(menu.classList.contains('show') && menu1.classList.contains('show')){
      menu.classList.remove('show')
      menu1.classList.remove('show')
    }else{
      menu.classList.add('show')
      menu1.classList.add('show')
    }

  }

  render() {
    return (

      <div id='homeContainer' >
        <header className="header  navbar-fixed-top">
          <div className="container">
            <div className="row">
              <nav className="navbar navbar-expand-md">
                <a className="navbar-brand" href="#"><img src={footerlogo}/></a>
                <button className="navbar-toggler" onClick={this.popMenu} type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse  " id="navbarNavDropdown">
                  <div class="collapse navbar-collapse justify-content-end" id="navbarNavDropdown1">
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}} className='about-us-margin'>
                      <Tabs value={this.state.tabIdx} onChange={this.handleTabChange}  className="navbar-nav mr-auto">
                        <a className="nav-link" href="/#/home">Home</a>
                        <a className="nav-link" href="/#/about-us">About Us</a>
                        <a className="nav-link" href="/#/about-payments">Payments</a>
                        
                      </Tabs>
                    </Box>
                  </div>
                  
                  
                </div>
              </nav>
            </div>
          </div>
        </header>

        
        {this.state.tabIdx === 0 &&
        <div className="banner">
          <img src={sliderbanner}/>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="banner_caption">
                  <h2>Experience <span>Automotive</span><br/><span>AI</span> at its best</h2>
                  <ul className="nav">
                  <a href={googlePlayStoreUrl}  target="_blank">
                    <li><img src={playstore1}/></li>
                  </a>
                    <a href={appleStoreUrl} target="_blank" >
                      <li><img src={appstore1}/></li>
                    </a>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
        {
          this.state.tabIdx === 1 &&
          <div className="banner">
          <img src={sliderbanner1}/>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="banner_caption">
                  <h2>About <span>Payment</span></h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
        {this.state.tabIdx === 2 &&
        <div className="banner">
          <img src={sliderbanner2}/>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="banner_caption">
                  <h2>gAbout <span>Us</span></h2>
                  <ul className="nav">
                    <li><a href={appleStoreUrl} target="_blank"><img src={appstore1}/></a></li>
                    <li><a href={googlePlayStoreUrl} target="_blank"><img src={playstore1}/></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
          
          
        
        {this.state.tabIdx === 0 &&
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <div className="col_loop">
                  <img src={members} alt="customer icon" className="home_page"/>
                  <h2 className="textColumns">Customer</h2>
                  <p className="blue"><span><b>iBottt</b></span> will drive you to<br/>save time & money</p>
                  <div className='bottom-aligned'>
                    
                    <div className="FormField">
                      <a href="/#/user/signIn">
                        <img src={StartHereIcon} className="startHere"/></a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="col_loop">
                  <img src={facility} alt="facility icon" className="home_page"/>
                  <h2 className="textColumns">Facility</h2>
                  <p>Join Our Certified <br/>Network!</p>
                  <div className="FormField bottom-aligned">
                    <a href="/#/signIn">
                      <img src={StartHereIcon} className="startHere"/></a>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="col_loop">
                  <img src={insurance} alt="insurance icon" className="home_page"/>
                  <h2 className="textColumns">Insurance & Manufacturers</h2>
                  <p>Please call us to see how iBottt AI<br/>will drive all your transactions<br/>within seconds.<br/>Call today 415-654-0003</p>

                  <div className="FormField bottom-aligned">
                    <a href="/#/insurance/signIn">
                    <img src={StartHereIcon} className="startHere"/></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        {
          this.state.tabIdx === 1 &&
          <AboutPaymentsPage />
        }
        {this.state.tabIdx === 2 &&
          <AboutPage />
        }
        
        <footer className="footer">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="footer_logo"><img src={footerlogo}/></div>
              </div>
              <div className="col-md-12">
                <ul className="nav nav-justified align-items-center footer_nav">
                  <li className="nav-item">
                    <a className="nav-link" href="mailto:info@ibottt.com">Contact Us: <span>info@ibottt.com</span></a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="mailto:techsupport@ibottt.com">Bug Reports: <span> techsupport@ibottt.com </span><span>6507626389 (leave voicemail if urgent)</span></a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/#/termsOfService">Terms of Services</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/#/privacyPolicy">Privacy Statement</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="row d-flex align-items-center bottom_foot">
              <div className="col-md-6">
                <div className="store_links">
                  <ul className="nav">
                    <li className="nav-item">
                      <a className="nav-link" href={appleStoreUrl}  target="_blank">
                        <img src={appstore}/>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href={googlePlayStoreUrl} target="_blank">
                        <img src={playstore}/>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                <div className="copyright_area">
                  <p>iBottt © 2024. All rights reserved
                  <a className="nav-link" href="mailto:techsupport@ibottt.com"  target="_blank">
                        <img src={chat}/>
                  </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}

function initTawkTO(){
  var Tawk_API = Tawk_API || {},
      Tawk_LoadStart = new Date();
  (function () {
    var s1 = document.createElement("script"),
        s0 = document.getElementsByTagName("script")[0];
    s1.async = true;
    s1.src =
        "https://embed.tawk.to/666480e99a809f19fb3b756e/1hvs9f40o";
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");
    s0.parentNode.insertBefore(s1, s0);
  })();
}

if (!window.location.href.includes('/signature')) {
  initTawkTO();
}

export default HomePage;
